// --------------------------------------------------------------------------------
import { JsonSchemaValidator } from '@Utils/JsonSchemaValidator';
import { ChartDateRange } from '@UI/Widgets/Things/Charts/ChartsJsonScheme';
// --------------------------------------------------------------------------------
export const enum PortKeys {
    DateRange = 'date_range',
    SelectedDateRange = 'selected_date_range'
}
// --------------------------------------------------------------------------------
export interface DateRangePickerData {
    alignment: DateRangePickerAlignment;
    fontColor: string;
    initialDateRangeDays: number;
    timePicker: boolean;
    timePickerIncrement: number;
    timePickerInitialRange: number;
}
// --------------------------------------------------------------------------------
export enum DateRangePickerAlignment {
    Left,
    Center,
    Right
}
// --------------------------------------------------------------------------------
export interface DateRangePickerState {
    dateRange: ChartDateRange;
}
// --------------------------------------------------------------------------------
export const DateRangePickerDataPortValidator = () => {
    return JsonSchemaValidator.GetInstance('date_range_picker_input_validator', {
        type: 'object',
        properties: {
            StartDate: { type: 'string' },
            EndDate: { type: 'string' }
        }
    });
};
// --------------------------------------------------------------------------------